/**
 * 阅后即焚时长选择纯逻辑（14.13c；旧版 chat_screen _afterViewOptions/
 * _afterViewLabel/_afterViewCompactLabel 同口径）。仅私聊使用。
 */

/** 可选时长（秒）：关闭/10s/30s/60s/5m/1h/1d（旧版 _afterViewOptions 同表） */
export const AFTER_VIEW_OPTIONS: readonly number[] = [0, 10, 30, 60, 300, 3600, 86400];

/** 选择器行文案（旧版 _afterViewLabel 同口径） */
export function afterViewLabel(seconds: number): string {
  if (seconds <= 0) return '关闭';
  if (seconds < 60) return `${seconds} 秒`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} 分钟`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} 小时`;
  return `${Math.floor(seconds / 86400)} 天`;
}

/** 徽章紧凑文案（旧版 _afterViewCompactLabel 同口径；关闭=空串） */
export function afterViewCompactLabel(seconds: number): string {
  if (seconds <= 0) return '';
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`;
  return `${Math.floor(seconds / 86400)}d`;
}
